import { render, staticRenderFns } from "./CreateTypeModal.vue?vue&type=template&id=33642510&lang=pug&"
import script from "./CreateTypeModal.vue?vue&type=script&lang=js&"
export * from "./CreateTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports